import React from "react";
import { TravelRequestForm } from "../TravelCreatePage";

const TravelAmendPage = () => <TravelRequestForm amendment />;
export default TravelAmendPage;
